import { Button, Text } from '@doda/io-react/common';
import {
  TAB_JOBDETAIL,
  TAB_PHOTOS,
} from '@doda/common/src/constants/properties/const';
import styles from './index.module.scss';
import { SEARCH_BY_DETAIL_CONDITIONS_HREF } from '../../constants';
import { useTab } from '../TabArea/hooks/useTab';
import { Tab } from '../../types/tab';

/**
 * SearchByDetailConditionsのProps
 */
interface Props {
  /** 求人ID */
  jid: string;
  /** 初期表示時のタブ */
  initialTab: Tab;
  /** 原稿種別 */
  wcnsId: string;
}

/**
 * 詳しい条件で求人を探す
 */
export const SearchByDetailConditions = ({
  initialTab,
  jid,
  wcnsId,
}: Props) => {
  const { currentTabName } = useTab({
    initialTab,
    jid,
    wcnsId,
  });
  if (currentTabName !== TAB_JOBDETAIL && currentTabName !== TAB_PHOTOS)
    return null;
  return (
    <section className={styles['jobSearchDetail-searchByDetailConditions']}>
      <Text as="h2" color="black_pc" size="20" weight="bold">
        詳しい条件で求人を探す
      </Text>
      <Button
        as="a"
        href={SEARCH_BY_DETAIL_CONDITIONS_HREF}
        size="M"
        variant="outline_gray"
        className={styles['jobSearchDetail-searchByDetailConditions__button']}
      >
        詳細条件から探す
      </Button>
    </section>
  );
};
